import { socialApiClient } from '@/shared/api-client/social-api-client';
import { exportToCSV } from '@/shared/utils/export-to-csv';

import type { ExcludeListPage } from './exclude-list-type';

export async function fetchExcludeList(
  params: {
    workspaceId: string;
    cursor: string | null;
    limit?: number;
  },
  signal?: AbortSignal,
): Promise<ExcludeListPage> {
  const response = await socialApiClient.get('creators/exclude-list', {
    searchParams: {
      workspace_id: params.workspaceId,
      cursor: params.cursor || undefined,
      limit: params.limit,
    },
    signal,
  });
  return response.json<ExcludeListPage>();
}

export async function excludeCreator(
  params: {
    workspaceId: string;
    creatorId: string;
  },
  signal?: AbortSignal,
): Promise<{ creator_id: string }> {
  await socialApiClient.post('creators/exclude-list', {
    json: {
      workspace_id: params.workspaceId,
      creator_id: params.creatorId,
    },
    signal,
  });

  return { creator_id: params.creatorId };
}

export async function restoreExcludedCreator(
  params: {
    workspaceId: string;
    creatorId: string;
  },
  signal?: AbortSignal,
): Promise<{ creator_id: string }> {
  await socialApiClient.delete('creators/exclude-list', {
    searchParams: {
      workspace_id: params.workspaceId,
      creator_id: params.creatorId,
    },
    signal,
  });

  return { creator_id: params.creatorId };
}

export async function exportExcludeList(workspaceId: string, signal?: AbortSignal) {
  const response = await socialApiClient.post('creators/exclude-list/export', {
    json: {
      workspace_id: workspaceId,
    },
    signal,
  });
  const text = await response.text();
  exportToCSV(text, 'exclude-list.csv');
}
